import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { TabView, TabPanel } from "primereact/tabview";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Tag } from "primereact/tag";
import { Button } from "primereact/button";
import { MultiSelect } from "primereact/multiselect";
import countries from '../data/country.json'
import OccupancyRate from "../front modules/OccupancyRate";
import formlabels from '../data/formlabels.json'
const AdminDashboard = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeIndex, setActiveIndex] = useState(0);
  const [activeBusIndex, setActiveBusIndex] = useState(0);
  const [activeChapitreIndex, setActiveChapitreIndex] = useState(0);
  const navigate = useNavigate();
  const allColumns = [
    {
      label: "Personal Data", items: [
        { id: 2, field: "Name", header: "First Name" },
        { id: 3, field: "Surname", header: "Last Name" },
        { id: 4, field: "BirthDate", header: "Birth Date" },
        { id: 11, field: "Email", header: "Email" },
        { id: 12, field: "Phone", header: "Phone" },
        { id: 13, field: "Address", header: "Address" }
      ]
    },
    {
      label: "Registration", items: [
        { id: 10, field: "WaitList", header: "Status" },
        { id: 8, field: "priceStr", header: "Price" },
        { id: 15, field: "FamilyID", header: "FamilyID" },
        { id: 1, field: "RegistrationDateTime", header: "Registration Date" }
      ]
    },
    {
      label: "Chapitre", items: [
        { id: 9, field: "ChapitreName", header: "Chapitre" }
      ]
    },
    {
      label: "Bus", items: [
        { id: 14, field: "BusLineName", header: "Bus Line Name" },
        { id: 5, field: "TripType", header: "Trip Type" },
        { id: 7, field: "DropOffStop", header: "Drop-Off Stop" },
        { id: 6, field: "GetAboardStop", header: "Boarding Stop" }
      ]
    }
  ];


  const defaultColumns = allColumns.slice(0, 5);
  const [selectedColumns, setSelectedColumns] = useState([
    { id: 2, field: "Name", header: "First Name" },
    { id: 3, field: "Surname", header: "Last Name" },
    { id: 10, field: "WaitList", header: "Status" },
    { id: 9, field: "ChapitreName", header: "Chapitre" },
    { id: 14, field: "BusLineName", header: "Bus Line Name" },
    { id: 5, field: "TripType", header: "Trip Type" },
    { id: 15, field: "FamilyID", header: "FamilyID" },

  ]);


  useEffect(() => {

    const fetchData = async () => {
      try {
        // const response = await fetch("http://localhost/chartresForm/src/backend/admin/adminDataJson.php", {
        const response = await fetch("https://chartrespilgerverein.ch/backend/admin/adminDataJson.php", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({}),
        });

        const jsonData = await response.json();
        console.log("✅ Server validation response:", jsonData);
        //TODO: clean error handling here
        if (jsonData.error) {
          console.error("❌ Invalid session, redirecting to login...");
          localStorage.clear();
          navigate("./login");
        } else {
          setData(jsonData);
        }
      } catch (error) {
        console.error("❌ Fetch error:", error);
        navigate("/login");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [navigate]);




  useEffect(() => {
    if (data) {
      setActiveBusIndex(data.BusLines.findIndex(bus => bus.IsEnabled === 1) || 0);
      setActiveChapitreIndex(data.chapitres.findIndex(chapitre => chapitre.IsEnabled === 1) || 0);
    }
  }, [data]);
  

  const truncateText = (text, maxLength = 20) => {
    return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
  };

  const countUsers = (list, idKey, idValue) => {
    return list.filter(user => user[idKey] === idValue).length;
  };

  const getUserStatus = (waitlist) => {
    return [
      <Tag value="Confirmed" severity="success" />,
      <Tag value="Waiting" severity="warning" />,
      <Tag value="Transfered" severity="Primary" />,
      <Tag value="Cancelled" severity="danger" />,
    ][waitlist]
    //return waitlist === 1 ? <Tag value="Waiting" severity="warning" /> : <Tag value="Confirmed" severity="success" />;
  };

  const downloadCSV = (data, filename) => {
    if (!data || data.length === 0) {
      console.warn("No data available to export.");
      return;
    }

    const separator = ",";
    const keys = Object.keys(data[0]);

    const csvContent = [
      keys.join(separator),
      ...data.map(row => keys.map(key =>
        `"${row[key] !== null && row[key] !== undefined ? row[key] : ""}"`
      ).join(separator))
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", `${filename}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const items = [
    { label: "Buses", icon: "pi pi-car" },
    { label: "Chapitres", icon: "pi pi-users" }
  ];

  if (loading) return <p>Loading data...
    <i className="pi pi-spin pi-spinner ml-2" style={{ fontSize: "1rem" }}></i>
  </p>;
  if (!data) return <p>Unauthorized access
    <i className="pi pi-exclamation-triangle ml-2" style={{ fontSize: "1rem" }}></i>
  </p>;

  return (
    <div className="card">

      <TabView>
        <TabPanel leftIcon="pi-car pi mr-2" header="Buses">
          <TabView activeIndex={activeBusIndex} onTabChange={(e) => {

            setActiveBusIndex(e.index);

          }}
            scrollable={true}>
            {data.BusLines.map((bus, index) => {
              const userCount = countUsers(data.users, "BusLineID", bus.BusLineID);
              const isDisabled = bus.IsEnabled === 0;
              return (
                <TabPanel key={`bus-${index}`} header={`${truncateText(bus.Name)}`}>
                  {bus.MaxSeats &&
                    <div className="grid ui-fluid ">
                      <div className="col-12 md:col-12 flex justify-content-between align-items-center">
                        <h2>{bus.Name} {countries[bus.Country].emoji}</h2>
                        <p>
                          &nbsp;<i className="pi pi-envelope"></i>&nbsp;
                          {bus.ContactEmail || "Not available"} &nbsp;|&nbsp;
                          <i className="pi pi-phone"></i>&nbsp;
                          {bus.ContactPhone || "Not available"}</p>
                      </div>
                      <div className="col-12 md:col-6">
                        {OccupancyRate(
                          bus.MaxSeats,
                          data.users.filter(user => user.BusLineID === bus.BusLineID && (user.WaitList==="0" || user.WaitList==="2") && ["oneway", "roundtrip"].includes(user.TripType)).length,
                          data.users.filter(user => user.BusLineID === bus.BusLineID && user.WaitList==="1" && ["oneway", "roundtrip"].includes(user.TripType)).length,
                          "Occupancy Rate to Paris",
                          formlabels['en'].almostFullWarning
                        )}
                      </div>
                      <div className="col-12 md:col-6">
                        {OccupancyRate(
                          bus.MaxSeats,
                          data.users.filter(user => user.BusLineID === bus.BusLineID && (user.WaitList==="0" || user.WaitList==="2") && ["return", "roundtrip"].includes(user.TripType)).length,
                          data.users.filter(user => user.BusLineID === bus.BusLineID && user.WaitList==="1" && ["return", "roundtrip"].includes(user.TripType)).length,
                          "Occupancy Rate from Chartres",
                          formlabels['en'].almostFullWarning
                        )}
                      </div>

                      <div className="col-12 md:col-12 flex-row justify-content-between align-items-center">
                        <h3>Passengers ({userCount}):</h3>
                        <div className="p-mb-3">
                          <MultiSelect
                            value={selectedColumns}
                            options={allColumns}
                            onChange={(e) => setSelectedColumns([...e.value].sort((a, b) => a.id - b.id))}
                            optionLabel="header"
                            optionGroupLabel="label"
                            optionGroupChildren="items"
                            placeholder="Select columns"
                            maxSelectedLabels={3}
                            className="w-full md:w-30rem"
                          />

                        </div>
                        <Button
                          icon="pi pi-download"
                          label="Download CSV"
                          className="p-button-sm p-button-outlined p-button-secondary"
                          onClick={() => downloadCSV(data.users.filter(user => user.BusLineID === bus.BusLineID), `bus_${bus.BusLineID}`)}
                        />
                      </div>
                    </div>
                  }

                  {userCount > 0 ? (
                    <DataTable value={data.users.filter(user => user.BusLineID === bus.BusLineID)} paginator rows={15}>
                      {selectedColumns.map((col) => (
                        <Column
                          sortable={true}
                          key={col.id}
                          field={col.field}
                          header={col.header}
                          body={col.field === "WaitList" ? (rowData) => getUserStatus(rowData.WaitList) : null}
                        />
                      ))}
                    </DataTable>
                  ) : (
                    <p>No passengers for this bus.</p>
                  )}
                </TabPanel>
              );
            })}
          </TabView>
        </TabPanel>
        <TabPanel leftIcon="pi-users pi mr-2" header="Chapitres">
          <TabView activeIndex={activeChapitreIndex} onTabChange={(e) => {

            setActiveChapitreIndex(e.index);

          }}
            scrollable={true}>
            {data.chapitres.map((chapitre, index) => {
              const userCount = countUsers(data.users, "ChapitreID", chapitre.ChapitreID);
              const isDisabled = chapitre.IsEnabled === 0;
              return (
                <TabPanel key={`chapitre-${index}`} header={`${truncateText(chapitre.Name)}`} >
                  <div className="grid ui-fluid ">
                    <div className="col-12 md:col-12">
                      <h2>{chapitre.Name}</h2>
                      <p>
                        {chapitre.BusLines.map((bus, index) => { return bus.Name + " " + countries[bus.Country].emoji + ""; }).join(" — ")}
                      </p>
                    </div>
                    <div className="col-12 md:col-12">
                      {chapitre.MaxPeople && OccupancyRate(chapitre.MaxPeople,  
                      data.users.filter(user => user.ChapitreID === chapitre.ChapitreID && (user.WaitList==="0" || user.WaitList==="2")).length,
                      data.users.filter(user => user.ChapitreID === chapitre.ChapitreID && user.WaitList==="1").length,
                        "Occupancy Rate", 
                        formlabels['en'].almostFullWarning)}
                    </div>

                    <div className="col-12 md:col-12 flex-row justify-content-between align-items-center">
                      <h3>Chapitre Members: ({userCount})</h3>
                      <div className="p-mb-3">
                        <MultiSelect
                          value={selectedColumns}
                          options={allColumns}
                          onChange={(e) => setSelectedColumns([...e.value].sort((a, b) => a.id - b.id))}
                          optionLabel="header"
                          optionGroupLabel="label"
                          optionGroupChildren="items"
                          placeholder="Select columns"
                          maxSelectedLabels={3}
                          className="w-full md:w-30rem"
                        />
                      </div>
                      <Button
                        icon="pi pi-download"
                        label="Download CSV"
                        className="p-button-sm p-button-outlined p-button-secondary"
                        onClick={() => downloadCSV(data.users.filter(user => user.ChapitreID === chapitre.ChapitreID), `chapitre_${chapitre.ChapitreID}`)}
                      />
                    </div>
                  </div>
                  {userCount > 0 ? (
                    <DataTable value={data.users.filter(user => user.ChapitreID === chapitre.ChapitreID)} paginator rows={15}>
                      {selectedColumns.map((col) => (
                        <Column
                          sortable={true}
                          key={col.id}
                          field={col.field}
                          header={col.header}
                          body={col.field === "WaitList" ? (rowData) => getUserStatus(rowData.WaitList) : null}
                        />
                      ))}
                    </DataTable>
                  ) : (
                    <p>No members in this chapitre.</p>
                  )}
                </TabPanel>
              );
            })}
          </TabView>
        </TabPanel>
      </TabView>
    </div>
  );
};

export default AdminDashboard;
